import { TierBadge } from "../bits";
import { Trophy } from "lucide-react";

function HonorSchoolRow({ s, i, sectionKey, tier, staff }) {
  return (
    <div data-testid={`honor-${sectionKey}-${tier}-${i}`}
      className={`flex items-center gap-3 rounded-xl px-3 py-2.5 ${i === 0 ? "bg-coral-100 dark:bg-surface2" : "bg-bg"}`}>
      <span className={`w-6 h-6 rounded-full text-[11px] font-black flex items-center justify-center text-white ${i === 0 ? "bg-coral-600" : "bg-turq-900"}`}>{i + 1}</span>
      <div className="flex-1 min-w-0">
        <div className="text-[12.5px] font-bold truncate">{s.name}</div>
        <div className="text-[10px] text-mutext">{s.office}</div>
      </div>
      <div className="text-left">
        {staff ? (
          <>
            <div className="font-head font-black text-sm text-turq-900 dark:text-turq-300">{s.volunteers} منسوب</div>
            <div className="text-[9.5px] text-mutext">{s.hours} ساعة · {s.impact_score} نقطة</div>
          </>
        ) : (
          <>
            <div className="font-head font-black text-sm text-turq-900 dark:text-turq-300">{s.pct}%</div>
            <div className="text-[9.5px] text-mutext">{s.impact_score} نقطة أثر</div>
          </>
        )}
      </div>
    </div>
  );
}

export function HonorSection({ honor }) {
  const sections = [
    { key: "secondary", title: "المدارس الثانوية — منافسة الطلاب", blocks: honor.secondary || [], staff: false },
    { key: "staff", title: "المراحل الأخرى (روضة / ابتدائية / متوسطة) — منافسة المنسوبين", blocks: honor.staff || [], staff: true },
  ];
  return (
    <section id="honor" className="max-w-6xl mx-auto px-5 pb-16">
      <div className="flex items-center gap-3 mb-6">
        <div className="w-10 h-10 rounded-xl bg-coral-600 flex items-center justify-center"><Trophy className="w-5 h-5 text-white" /></div>
        <div>
          <h2 className="font-head font-black text-2xl">لوحة الشرف — محرك العدالة بالشرائح</h2>
          <p className="text-xs text-mutext">الثانويات تتنافس بعطاء الطلاب، والمراحل الأخرى تتنافس بعطاء المنسوبين — كل مدرسة مع نظيراتها في نفس الشريحة بعدالة</p>
        </div>
      </div>
      {sections.map((section) => (
        <div key={section.key} data-testid={`honor-section-${section.key}`} className="mb-8 last:mb-0">
          <h3 className="font-head font-bold text-base mb-3 text-turq-900 dark:text-turq-300">{section.title}</h3>
          <div className="grid md:grid-cols-3 gap-4">
            {section.blocks.map((tierBlock) => (
              <div key={tierBlock.tier} className="bg-surface rounded-3xl border border-brd p-5 shadow-md shadow-turq-900/5">
                <div className="flex items-center justify-between mb-4">
                  <TierBadge tier={tierBlock.tier} />
                  <span className="text-[10.5px] text-mutext">{tierBlock.info.range}</span>
                </div>
                {tierBlock.schools.length === 0 && <div className="text-xs text-mutext text-center py-6">لا توجد مدارس بعد</div>}
                <div className="space-y-2.5">
                  {tierBlock.schools.map((s, i) => (
                    <HonorSchoolRow key={s.name} s={s} i={i} sectionKey={section.key} tier={tierBlock.tier} staff={section.staff} />
                  ))}
                </div>
              </div>
            ))}
          </div>
        </div>
      ))}
    </section>
  );
}
